import { render, staticRenderFns } from "./CalendarClockIcon.vue?vue&type=template&id=4b941eb4&scoped=true&"
import script from "./CalendarClockIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalendarClockIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b941eb4",
  null
  
)

export default component.exports